import { atom } from "recoil";

type FactorStepsT = Array<FactorStatusT>;

const factorStepsAtom = atom({
  key: "@factor_steps_atom",
  default: <FactorStepsT>[],
});

export default factorStepsAtom;
